import Vue from 'vue'
import { ModelSelect } from 'vue-search-select'

import 'vue-search-select/dist/VueSearchSelect.css'

Vue.component('v-select', ModelSelect)
